import { Link } from "react-router-dom";
import "./intro.css";
import Me from "./../../img/nz.png";
import {FaTaxi} from 'react-icons/fa';
const Intro = () => {
  return (
    <div className="i">
      <div className="i-left">
      <div id="mySidenav" className="sidenav">
 <Link to="/" id="about">Home<br/>&nbsp;&nbsp;&nbsp;&nbsp;&#127969;</Link>
  <Link to="/products" id="projects"> Services<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<FaTaxi/></Link>
   <Link to="/about" id="blog">About <br/>&nbsp;&nbsp;&nbsp;&nbsp;&#9739;</Link>
  <Link to="/contact-us" id="contact">Contact <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#9743;</Link></div>
        <div className="i-left-wrapper">
          <h2 className="i-intro1">Hello, Welcome to </h2>
          {/* <h2 className="i-intro">Welcome to </h2> */}
          <h1 className="i-name">Radhe Krishna Tour & Travels</h1>
          <h1 className="i-name1">We can accommodate different types of taxi services like</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">OutStation</div>
              <div className="i-title-item">Rentals</div>
              <div className="i-title-item">Local</div>
              <div className="i-title-item">Family tour</div>
              <div className="i-title-item">Char Dham Yatra</div>
              {/* <div className="i-title-item">Sedan</div>
              <div className="i-title-item">Traveller</div>
              <div className="i-title-item">SUV</div>
              <div className="i-title-item">Mini Bus</div> */}
           
            </div>
          </div>
        </div>
      </div>
      <div className="i-right">
        <img src={Me} alt="" className="i-img" />
      </div>
    </div>
  );
};
export default Intro;